
			// This file is auto-generated.
			// Do not edit this file manually.
			
			export const environment = {
				production: true,
				apiUrl: '-',
				apiServer: 'https://crps-web-prod.azurewebsites.net/cfsapi/',
				ws: 'wss://ws.bitstamp.net',
				hmr: false,
				recaptcha_v3_site_key: '6Lermd4UAAAAAJedqZqcGtYYNd9VHhzagx0nycZe'
			  };
